import type { LSelectType } from '@/components/organisms/forms/entry/EntryForm.vue'

export function getSelectValue(selectValue: LSelectType): string {
  switch (typeof selectValue) {
    case 'string':
      return selectValue
    case 'object':
      if (Array.isArray(selectValue)) {
        return selectValue[0]
      }
      return selectValue ?? ''
    default:
      return ''
  }
}
